import React from "react";
import { useLeaderboard } from "../useWords";

export default function Leaderboard() {
  const { words, loading, loadingMore, hasMore, loadMore } = useLeaderboard();

  const ranked = words.filter((w) => w.comparisons > 0);
  const unranked = words.filter((w) => w.comparisons === 0);

  if (loading) {
    return (
      <div className="loading-state">
        <div className="loading-spinner" />
        <p>Loading leaderboard…</p>
      </div>
    );
  }

  if (words.length === 0) {
    return (
      <div className="leaderboard">
        <div className="lb-empty">
          <p>No votes yet — be the first!</p>
          <p className="lb-empty-sub">Rankings will appear once words have been compared.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="leaderboard">
      <div className="leaderboard-header">
        <span className="lb-col-rank">#</span>
        <span className="lb-col-word">Word</span>
        <span className="lb-col-elo">
          Score
          <span className="lb-score-tip" title="Score is calculated from head-to-head votes. Beating higher-ranked words earns more points.">?</span>
        </span>
        <span className="lb-col-matches">Matches</span>
      </div>

      <div className="leaderboard-rows">
        {/* Ranked words with actual scores */}
        {ranked.map((w, i) => (
          <div key={w.id} className={`lb-row ${i < 3 ? "lb-row--top" : ""}`}>
            <span className="lb-col-rank">
              {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : i + 1}
            </span>
            <span className="lb-col-word lb-word-text">{w.word}</span>
            <span className="lb-col-elo">{w.elo}</span>
            <span className="lb-col-matches">{w.comparisons}</span>
          </div>
        ))}

        {/* Unranked words — shown with a divider if any ranked exist */}
        {unranked.length > 0 && ranked.length > 0 && (
          <div className="lb-divider">
            <span>Not yet ranked</span>
          </div>
        )}
        {unranked.map((w) => (
          <div key={w.id} className="lb-row lb-row--unranked">
            <span className="lb-col-rank">—</span>
            <span className="lb-col-word lb-word-text">{w.word}</span>
            <span className="lb-col-elo lb-col-elo--unranked">—</span>
            <span className="lb-col-matches">0</span>
          </div>
        ))}
      </div>

      {hasMore && (
        <div className="lb-load-more">
          <button
            className="load-more-btn"
            onClick={loadMore}
            disabled={loadingMore}
          >
            {loadingMore ? "Loading…" : "Load more words"}
          </button>
        </div>
      )}

      {!hasMore && (
        <p className="lb-end-note">
          All {ranked.length} ranked · {unranked.length} unranked
        </p>
      )}
    </div>
  );
}
